{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowNeIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowNeIcon = React.forwardRef<SVGSVGElement, ArrowNeIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 110 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M51.454 61.1811C38.6257 73.8037 25.7914 86.4199 12.9512 99.0294C10.3863 101.538 7.64747 103.879 4.87313 106.157C4.41031 106.529 3.84581 106.754 3.25343 106.801C2.66106 106.847 2.0683 106.715 1.55266 106.419C0.695483 105.977 0.4953 104.334 1.22449 103.334C1.92809 102.368 2.55616 101.333 3.34573 100.442C8.38378 94.7561 13.2841 88.9343 18.5545 83.471C29.384 72.2476 40.362 61.1673 51.3779 50.129C61.8288 39.6538 72.4227 29.3231 82.911 18.8821C84.5945 17.2065 86.0615 15.3136 87.5914 13.4863C87.6753 13.3476 87.7229 13.1901 87.73 13.0282C87.7371 12.8663 87.7035 12.7051 87.6321 12.5596C87.403 12.2701 86.8936 11.9092 86.6245 11.9886C81.6606 13.4561 76.6482 14.7931 71.7795 16.5396C60.4597 20.603 48.7945 23.3655 37.1196 26.1143C35.2011 26.5652 33.2138 27.0614 31.2782 26.0834C30.9264 25.9055 30.3371 25.5873 30.3594 25.3877C30.3862 24.6235 30.6016 23.8778 30.9868 23.2172C31.4779 22.5945 32.1324 22.1203 32.8771 21.8474C35.4952 20.8629 38.1349 19.925 40.8036 19.0908C59.8729 13.1031 78.9605 7.17565 98.0212 1.16228C105.211 -1.10668 109.843 -0.969494 109.573 10.1147C109.496 13.3091 109.399 16.5206 109.008 19.6861C107.194 34.3697 105.313 49.0443 103.363 63.7099C103.04 65.6715 102.564 67.6049 101.94 69.4923C101.565 70.7564 100.482 71.3123 99.2414 71.4863C97.8762 71.6779 95.6859 70.4545 95.2042 69.4352C94.1344 67.1728 94.0995 64.7627 94.2689 62.3796C94.92 53.2059 95.6538 44.0382 96.3928 34.8718C96.8746 28.8991 97.4312 22.9357 97.9025 16.9643C97.9254 16.669 97.5086 16.2391 97.1942 16.0513C97.042 15.9844 96.8758 15.9554 96.71 15.9668C96.5441 15.9783 96.3835 16.0298 96.2419 16.117C94.4475 17.6922 92.6202 19.2365 90.9439 20.9305C77.7226 34.2914 64.5191 47.67 51.3332 61.0662L51.454 61.1811Z" fill={color}/>

      </svg>
    )
  }
)

ArrowNeIcon.displayName = 'ArrowNeIcon'
